<template>
  <div>

    <div style="position: absolute;top: 0;right: 0;left: 0;bottom: 0;overflow: hidden;">
      <img style="object-fit: cover;width: calc(100% - 350px);height: 100%;" src="../../assets/img/login.png">
    </div>



    <div class="rightContent">
      <div class="rightContent-body" v-if="!multipleCheck" >
        <div class="localAccount">
          <img
            style="width: 90%; height: 18%"
            src="../../assets/img/icontitle_1.png"
          />
          <h1>{{ $t("login.loginTitle1") }}</h1>
          <h2>{{ $t("login.loginTitle2") }}</h2>
          <a-form :form="form">
            <a-col style="text-align: left; font-size: 18px">{{
              $t("login.Username")
            }}</a-col>
            <a-form-item>
              <a-input
                @pressEnter="handleSubmit"
                style="font-size: 16px"
                v-decorator="[
                  'username',
                  {
                    rules: [
                      {
                        required: true,
                        message: $t('login.PleaseUsername'),
                      },
                    ],
                  },
                ]"
              >
              </a-input>
            </a-form-item>
            <a-col style="text-align: left; font-size: 18px">{{
              $t("login.Password")
            }}</a-col>
            <a-form-item>
              <a-input
                  id="password"
                style="font-size: 16px"
                v-decorator="[
                  'password',
                  {
                    rules: [
                      {
                        required: true,
                        message: $t('login.PleasePassword'),
                      },
                    ],
                  },
                ]"
                type="password"
                @pressEnter="handleSubmit"
              >
              </a-input>
            </a-form-item>
          </a-form>

          <a-row type="flex" justify="space-between" style="margin-top: 10px">
            <a-col>
              <a-checkbox :checked="keepMeSigned" @change="keepMeChange"
                >{{ $t("login.KeepIn") }}
              </a-checkbox>
            </a-col>
          </a-row>

          <a-row type="flex" justify="space-between" style="margin: 15px 0">
            <a-col style="width: 100%">
              <a-button
                id="loginBtnSign"
                size="large"
                style="width: 100%; background-color: #0b97c4"
                :loading="loginLoading"
                @click="handleSubmit"
                type="primary"
                >{{ $t("login.SignIn") }}</a-button
              >
            </a-col>
          </a-row>
        </div>
        <p class="infoError login-action-error-message" v-if="isError">
          {{ loginFailureMsg }}
        </p>
           <a-row id="login_footer" style="bottom: 0" type="flex" justify="start" >
            <a-col style="margin-left: 50px;color: #545D61;" aria-hidden="true">
              <router-link
                style="font-size: 15px; visibility: hidden; pointer-events: none"
                :to="{ path: '/sign' }"
                tag="div"
                tabindex="-1"
                >{{ $t("login.SignUPnow") }}</router-link
              >
            </a-col>
            <a-col style="margin-left: 60px;color: #545D61;">
              <span @click="goForgot" style="cursor: pointer; font-size: 15px">
                {{ $t("login.ForgotPassword") }}
              </span>
            </a-col>
          </a-row>
      </div>



      <div class="rightContent-body" v-if="multipleCheck">
        <div class="checkLocalAccount">
          <img style="width: 90%; height: 18%" src="../../assets/img/icontitle_1.png" />
          <h1 style="fond-size: 10px">{{ $t("login.loginTitle3") }}</h1>
          <h2 style="fond-size: 5px">{{ $t("login.loginTitle4") }}</h2>
          <span class="me_icon"></span>

          <select  style='width: 80%; height: 35px ;border-radius: 25px;padding-left: 35px;margin-bottom: 20px'>
            <option class="display: inline-block;max-width: 80px;overflow: hidden;text-overflow: ellipsis;white-space: nowrap; " v-for="item in userEmailList"   v-bind:key="item"  value="item">{{item}}</option>
          </select>

          <div>
            <a href="javascript:;" :disabled="sendMsgShow == 'active' ? true : false"  :class="sendMsgShow" @click="sendMessage" style="color: #282828 ;display: inline-block;width: 100%;margin-bottom: 10px; ;">
              <span class="message_icon"></span>
              <span
                style="display: inline-block;  float: left; position: relative;left: 10px;top: 8px; font-size: 14px;">透過以下電話號碼接收驗證碼：**** **{{mobileNum.length > 2 ? mobileNum.substring(mobileNum.length-2,mobileNum.length) : '**' }}
                <br /> <span style="float: left; position: relative">需支付一般簡訊費用 </span> </span><br />
            </a>

            <a href="javascript:;"  :disabled="sendEmailShow == 'active' ? true : false"  :class="sendEmailShow" @click="sendEmail"  style="color: #282828 ;display: inline-block;width: 100%;">
              <span class="computer_icon"> </span>
              <span
                style="display: inline-block;  float: left; position: relative;left: 10px;top: 15px;font-size: 14px">透過電郵接收驗證碼<span v-if="time > 0">({{time}}s)</span></span>
            </a>
            <div>
            <h5 style="float: left; position: relative;left: 40px;top: 15px;margin-top: 0px;margin-bottom: 0px">驗證碼</h5>
            <input
              style="float: left; position: relative;left: -10px;top: 40px; border: #808080 solid 1px;  border-radius: 3px;height: 26px;width: 70%;"
              type="text" name="yanzhengma" v-model="verificationCode" placeholder="請輸入正確的驗證碼" onfocus="this.placeholder=''" onblur="this.placeholder='請輸入正確的驗證碼'">
          
            <p  style="float: left; position: relative;left: 40px;top: 45px;color: red;font-size: 14px;" v-if="verificationCodeError" >{{verificationCodeErrorMsg}}</p>
            <a-row type="flex" justify="space-between"
              style="margin: 30px 0;float: left; position: relative;left: 12px;top: 55px;width: 250px">
              <a-col style="width: 100%">
                <a-button id="loginBtnSign" size="large" style="width: 100%; background-color: #0b97c4"
                  :loading="loginLoading" @click="handleSubmit2" type="primary">{{ $t("login.SignIn") }}</a-button>
              </a-col>
            </a-row>
          </div>
          </div>
        </div>
      </div>



    </div>
  </div>
</template>
<script>
  import ajax from "../../api/ajax";
  import api from "../../api/url";
  import cookie from "../../api/cookie";
  import moment from "moment";
  import encrypt from "@assets/js/encrypt-DES";
  export default {
    data() {
      return {
        clientHeight: 0, // 声明data
        form: this.$form.createForm(this), // 表单注册
        keepMeSigned: false, // 是否保持登录
        isError: false, // 提示信息
        multipleCheck: false,
        verificationCode: null,
        verificationCodeError: false,
        verificationCodeErrorMsg: '',
        lang: false, // 语言
        loginLoading: false,
        mobileNum: '',
        sendMsgShow: '' ,
        sendEmailShow: '' ,
        time:0,
        authorizationCode: '',
        languages: [{
            code: "Eglish",
            codeDesc: "Eglish"
          },
          {
            code: "中文",
            codeDesc: "中文"
          },
        ],
        userEmailList:[] ,
        loginFailureMsg:"",
      };
    },
    created() {
      //如果没有这句代码，select中初始化会是空白的，默认选中就无法实现
      this.couponSelected = this.languages[0].code;
    },
    mounted() { //监控页面高度
      var _this = this;
      // 挂载读取页面高度
      _this.setClientHight();
      // 窗口页面高度变更
      window.onresize = function () {
        _this.setClientHight();
      }
    },
watch: {
  verificationCode: {
   handler(newVal) {
       this.verificationCodeError = false
   },
   deep: true,　　immediate: false,
  }
}
    ,
    methods:
     {
         sendEmail(){
           // 校验邮箱
           var emailReg = /^([a-zA-Z0-9]+[_|\_|\.]?)*[a-zA-Z0-9]+@([a-zA-Z0-9]+[_|\_|\.]?)*[a-zA-Z0-9]+\.[a-zA-Z]{2,3}$/;
          if(!emailReg.test(this.userEmailList[0])){
               this.verificationCodeError = true;
               this.verificationCodeErrorMsg = "Email address is invalid."
               return;
          }

          // 设定样式
        this.sendEmailShow = 'active';
          // 发请求发邮件    
        ajax.get(api.USERSENDEMAIL,{email: this.userEmailList[0]}).then(res=>{
          if(res.code == 200){
              // this.$message.success('The email is sent successfully and resend 60 seconds later.');
          }else{
             this.$customMessage.error(res.msg);
          }
        })
        // 定时恢复样式
        this.time = 59;
        this.timer = setInterval(()=>{
          this.time -- ;
          if(this.time == 0){
            this.sendEmailShow = '';
             clearInterval(this.timer);
          }        
        }, 1000);
      },
      sendMessage(){
        // this.sendMsgShow = 'active';
        this.$customMessage.error('This function is not enabled.');
      // 定时恢复样式
        // this.timer = setTimeout(()=>{
        //   this.sendMsgShow = '';
        //    clearInterval(this.timer);
        // }, 10000);

      },
      setClientHight() { // 当页面高度发生变化触发事件 
        var _this = this;
        _this.clientHeight = `${document.documentElement.clientHeight}`; //设置页面高度
        var doc = document.getElementById('login_footer');
        if (doc != undefined && doc != 'null') {
          if (_this.clientHeight > 490) {
            doc.style.position = 'fixed';
          } else {
            doc.style.position = 'static';
          }
        }
      },
      goForgot() {
        let val = this.form.getFieldsValue(["username"]);
        this.$router.push({
          path: "/forgot",
          query: {
            name: val.username
          }
        });
      },
      //        保持登录
      keepMeChange(e) {
        this.keepMeSigned = e.target.checked;
      },
      //        语言切换
      checkoutLang() {
        this.lang = !this.lang;
        if (this.lang) {
          this.$i18n.locale = "zh";
        } else {
          this.$i18n.locale = "en";
        }
      },
      //        提交
      handleSubmit() {
        this.form.validateFields((err, values) => {
          if (!err) {
          this.loginLoading = true;
           let utcTime = moment.utc().valueOf();
            values['password'] = encrypt.encryptByDES(values['password'],Math.floor(utcTime/ 30000).toString())
            values['timestamp'] = utcTime;
            ajax.post(api.AUTHORIZATIONCODE + "?from=PC", values).then((res) => {
              this.loginLoading = false;
              if (res.code == 200) {
                this.multipleCheck = res.data.multipleCheck
              if(! this.multipleCheck){ // 是否需要二次验证
                  ajax.post(api.LOGINAPI + "?from=PC", values).then((res) => {
                      this.loginLoading = false;
                      if (res.code == 200) {
                        this.infoErrorMsg = "";
                        let token = res.data;
                        if (typeof token === 'string' && token.startsWith("Bearer ")) {
                          token = token.replace("Bearer ", "");
                        }
                        sessionStorage.setItem("logout", "/login");
                        sessionStorage.setItem("token", token);
                        this.$sessionManagerService.setCurrentUsername(values.username);
                        this.isError = false;
                        this.$router.push({
                          path: "/page"
                        });
                        ajax.get(api.CODEMAST).then((res) => {
                          sessionStorage.setItem("localData", JSON.stringify(res.data));
                        });

                        ajax.get(api.SYSTEMPARAM).then(res => { //查询当前Project所有系统参数
                          sessionStorage.setItem("systemParam", JSON.stringify(res.data));
                        });

                      } else {
                        this.form.setFieldsValue({ password: '' });
                        document.getElementById('password').focus();
                        this.isError = true;
                        this.loginFailureMsg = res.msg
                      }
                  });
               }else{
                 this.authorizationCode = res.data.AuthorizationCode
                 this.userEmailList.push(res.data.email)
                 this.mobileNum = res.data.mobileNum
               }            
              } else {
                this.isError = true;
                this.loginFailureMsg = res.msg
              }
            });
          }
        });
      },
      handleSubmit2() {
        let params = {
          code : this.authorizationCode,
          verificationCode: this.verificationCode
        }
        ajax.post(api.LOGINAPI + "?from=PC", params).then((res) => {
              this.loginLoading = false;
              if (res.code == 200) {
                this.infoErrorMsg = "";
                let token = res.data;
                if (typeof token === 'string' && token.startsWith("Bearer ")) {
                  token = token.replace("Bearer ", "");
                }
                sessionStorage.setItem("logout", "/login");
                sessionStorage.setItem("token", token);
                this.$sessionManagerService.setCurrentUsername(this.userName);
                this.isError = false;
                this.$router.push({
                  path: "/page"
                });
                ajax.get(api.CODEMAST).then((res) => {
                  sessionStorage.setItem("localData", JSON.stringify(res.data));
                });
                // ajax.get(api.SYSTEMPARAM).then(res => { //查询当前Project所有系统参数
                //   sessionStorage.setItem("systemParam", JSON.stringify(res.data));
                // });
              } else {
                this.verificationCodeError = true;
                this.verificationCodeErrorMsg = res.msg
              }
        });
      }
    },
  };
</script>
<style lang="less">

.active {
  background-color: #E8F0FE;
  color: #787A81 !important;
}

  .checkLocalAccount {

    .has-error .ant-form-explain,
    .has-error .ant-form-split {
      text-align: left;
    }
    a:hover{
      background: #E8F0FE;
    }
    h2 {
      font-size: 13px;
      margin: 10px 0;
      // font-weight: bold;
    }

    h1 {
      font-size: 25px;
      margin: 10px 0;
      // font-weight: bold;
    }

    .me_icon {
      border-radius: 100%;
      float: left;
      position: relative;
      left: 50px;
      top: 3px;
      background: url("../../assets/img/login_me.png") no-repeat;
      background-size: 100% 100%;
      width: 30px;
      height: 30px;
      display: block;

    }

    .message_icon {
      float: left;
      position: relative;
      left: 0px;
      ;
      top: -5px;
      background-image: url("../../assets/img/login_message.png");
      background-repeat: no-repeat;
      background-size: 100% 100%;
      width: 30px;
      height: 30px;
      display: inline-block;
      margin: 10px 0px;

    }

    .computer_icon {
      float: left;
      position: relative;
      left: 0px;
      ;
      top: 0px;
      background-image: url("../../assets/img/login_computer.png");
      background-repeat: no-repeat;
      background-size: 150% 150%;
      background-position: left -6px top -7px;
      width: 30px;
      height: 30px;
      display: inline-block;
      margin: 10px 0px;
    }
  }





  // #test1{
  // }
  // #login_login {
  //   background: url(../../assets/img/login.png) no-repeat;
  //   width: 100%;
  //   height: 100vh;
  //   background-size: 100% 100%;
  // }
  .rightContent {
    width: 350px;
    float: right;
    height: 100vh;
    background: #fff;
  }

  .rightContent-body {
    padding: 40px 30px 0px;
    margin-top: auto;
    margin-bottom: auto;
    height: 100%;
    background-color: #fff;
    position: relative;
    border-radius: 3px;
    text-align: center;
    overflow-y: auto;
    ;
  }

  .rightContent-body .localAccount h1 {
    font-size: 30px;
    margin: 10px 0;
    font-weight: 700;
  }

  .rightContent-body .localAccount h2 {
    font-size: 20px;
    margin: 10px 0;
    font-weight: 700;
  }

  .con {
    text-align: center;
    width: 100%;
    display: table;
    height: 100vh;
    padding: 0;
  }

  .row {
    width: 100%;
    margin: 0;
    display: table-cell;
    vertical-align: middle;
  }

  .panel-default {
    padding: 40px 30px;
    margin-top: auto;
    margin-bottom: auto;
    height: 100%;
    background-color: #fff;
    position: relative;
    border-radius: 3px;

    .Langcheckout {
      position: absolute;
      top: -1px;
      right: -1px;
      width: 30px;
      height: 30px;
      cursor: pointer;
    }

    .panel-body {
      max-width: 380px;
      width: auto;
      margin: 0 auto;
      padding: 0;

      .panel-body-title {
        display: flex;
        align-items: center;
        justify-items: center;
        width: 190px;
        margin: 0 auto;

        .panel-body-titleR {
          font-family: Mv Boli;
          font-size: 22px;
          font-weight: 800;
        }

        .panel-body-titleL {
          margin: 0;
          height: 100px;
          width: 100px;
          display: block;
        }
      }

      .localAccount {

        .has-error .ant-form-explain,
        .has-error .ant-form-split {
          text-align: left;
        }

        h2 {
          font-size: 20px;
          margin: 10px 0;
          font-weight: bold;
        }

        h1 {
          font-size: 30px;
          margin: 10px 0;
          font-weight: bold;
        }
      }
    }
  }


.login-action-error-message {
  white-space: pre-line;
  font-size: 16px;
  line-height: 16px;
  color: red;
}
</style>
